<template>
  <div>

    <div class="my-container" style="position: relative;">
      <h2>Dataset details</h2>
      <el-image :src="icon_path" v-on:click="showOrHide"
                style="position: absolute;width: 40px;height:40px;right: 10px;top:5px;z-index: 9999"/>
      <div v-show="showDatasetDetails" style="margin: 1px">
        <el-table
            :data="datasetDetails"
            :header-cell-style="{margin: '0',padding: '0', color: 'black'}"
            :cell-style="{margin: '0',padding: '0', color: 'black'}"
            stripe
            border>
          <el-table-column
              prop="title"
              label="title"
              min-width="30px">
          </el-table-column>
          <el-table-column
              prop="content"
              label="content">
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="my-container">
      <h2>Spatial marker gene expression</h2>
      <div id="content">
<!--        <img :src="SVG.path" alt="" height="600px" width="600px" style="position: absolute;z-index: -1;margin-left: 510px">-->
        <div id="left" class="my-div-center">
          <el-form ref="form" :model="formData" label-width="100px" size="small" style="width: 80%;float: right;">
            <el-form-item>
              <span slot="label">
                <span style="color: black"><b>Sample:</b></span>
              </span>
              <el-select v-model="formData.Array"
                         placeholder="please select"
                         clearable
                         filterable
                         @change="getGene">
                <el-option
                    v-for="item in name"
                    :key="item"
                    :label="item"
                    :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <span slot="label">
                <span style="color: black"><b>Gene:</b></span>
              </span>
              <el-select v-model="formData.Gene"
                         clearable
                         filterable
                         placeholder="please select">
                <el-option
                    v-for="item in genelist"
                    :key="item.gene"
                    :label="item.gene"
                    :value="item.gene">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <span slot="label">
                <span style="color: black"><b>Size:</b></span>
              </span>
              <el-input v-model="formData.Size" placeholder="please choose size(1.0-2.2)" />
            </el-form-item>
            <el-form-item>
              <span slot="label">
                <span style="color: black"><b>Img-alpha:</b></span>
              </span>
              <el-input v-model="formData.Img_alpha" placeholder="please choose alpha(0-1)"/>
            </el-form-item>
            <el-form-item>
              <span slot="label">
                <span style="color: black"><b>Plot-alpha:</b></span>
              </span>
              <el-input v-model="formData.Plot_alpha" placeholder="please choose alpha(0-1)"/>
            </el-form-item>
            <el-form-item>
              <el-button @click="onSubmit" style="color: black">submit</el-button>
              <template v-if=" imgPath !== '' ">
                <el-button @click="download">download</el-button>
              </template>
            </el-form-item>
          </el-form>
        </div>
        <div id="right">
          <div  style="width: 600px;height: 600px;">
            <div v-bind:class="echartsClassType">
<!--              使用echarts绘图-->
              <div class="my-div-center">
                <div id="main" style="height: 600px;width: 600px" ></div>
              </div>
<!--              使用svg绘图-->
<!--              <svg id="mySVG" height="600px" width="600px" style="border:2px solid #aaaaaa;">-->
<!--                <g>-->
<!--                  <image v-bind:xlink:href="SVG.path" x="0" y="0" >-->
<!--                    &lt;!&ndash;                      <animate attributeName="x" values="160;40;160;" dur="3s" repeatCount="indefinite"/>&ndash;&gt;-->
<!--                  </image>-->
<!--                </g>-->
<!--              </svg>-->
<!--              <button v-on:click="drawSVG()">draw</button>-->
            </div>
            <div v-bind:class="rClassType" >
              <el-image :src="imgPath" fit="contain">
                <div slot="placeholder" class="image-slot">
                  <i class="el-icon-loading"></i>loading
                </div>
                <div slot="error" class="image-slot" style="font-size: 300px;color: gray">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </div>

          <!--          <img :src=imgPath alt="no pic here" width="100%">-->

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts/core';
import { GridComponent } from 'echarts/components';
import { ScatterChart } from 'echarts/charts';
import { UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';
import Vue from "vue";

echarts.use([GridComponent, ScatterChart, CanvasRenderer, UniversalTransition]);
export default {
  name: "my_marker",
  data() {
    return{
      isSVG: true,
      echartsClassType: 'class_hide',
      rClassType: 'class_show',
      isFirst: true,
      datasetDetails: [],
      showDatasetDetails: false,
      icon_path: require('../../assets/show.png'),
      name: [],
      genelist: [],
      SVG:{
        path: '',
        data: []
      },
      formData: {
        datasetID: '',
        Array: '',
        Gene: '',
        Size: '1',
        Img_alpha: '0.5',
        Plot_alpha: '0.5'
      },
      imgPath: require("@/assets/sample.png"),
    }
  },
  mounted() {
    this.initEcharts();
    this.getDatasetInformation();
    this.getMarkerArray()
  },
  methods: {
    getDatasetInformation() {
      let _this = this
      console.log(_this.$route.params.id)
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/dataset/'+ _this.$route.params.id)
          .then(function (response){
            console.log('dataset:')
            console.log(response)
            _this.datasetDetails = response.data.details
          })
    },
    showOrHide() {
      console.log("before:"+this.showDatasetDetails)
      if (this.showDatasetDetails === false){
        this.showDatasetDetails = true
        this.icon_path = require('../../assets/hide.png')
        // this.datasetDetail_tip = 'hide'
      }else {
        this.showDatasetDetails = false
        this.icon_path = require('../../assets/show.png')
        // this.datasetDetail_tip = 'show'
      }
      console.log("after:"+this.showDatasetDetails)
    },
    isEcharts(){
      let _this = this
      //判断是不是SVG图像
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/marker/isSVG/'+ _this.$route.params.id + '/' + _this.formData.Array)
          .then(function (response){
            _this.isSVG = response.data.isSVG
            console.log("isSVG: "+ response.data.isSVG)
            _this.SVG.path = response.data.path
            _this.isSVG = true
            if (_this.isSVG === true){
              _this.echartsClassType = 'class_show'
              _this.rClassType = 'class_hide'
            }else {
              _this.echartsClassType = 'class_hide'
              _this.rClassType = 'class_show'
            }
          })
    },
    getMarkerArray(){
      let _this = this
      console.log(_this.$route.params.id)
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/marker/'+ _this.$route.params.id)
          .then(function (response){
            _this.name = response.data.name
            // console.log('array:'+ _this.name)
            _this.formData.Array = _this.name[0]
            _this.formData.Gene = ''
            _this.getGene()
          })
    },
    getGene(){
      let _this = this
      //SVG
      // _this.clearSVG()
      _this.isSVG = ''
      _this.SVG.height = ''
      _this.formData.Gene = ''
      _this.genelist = []
      _this.SVG.data = []
      // console.log("Changed Array:"+_this.formData.Array)
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/marker/'+ _this.$route.params.id + '/' + _this.formData.Array)
          .then(function (response){
            _this.genelist = response.data.topgene
            // console.log("genelist get!")
            _this.formData.Gene = _this.genelist[0].gene
            // console.log(_this.formData)
            _this.isEcharts()
            // setTimeout(function (){
            //   _this.onSubmit()
            // },2000)
          })
    },
    onSubmit(){
      let _this = this
      _this.formData.datasetID = _this.$route.params.id
      console.log("Array:"+_this.formData.Array)
      if (_this.isSVG === true){
        Vue.prototype.$message.info("drawing picture, please wait...")
        console.log("request SVG data")
        //pic
        // _this.$axios.get(
        //     'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/marker/gene/echarts/'
        //     + _this.$route.params.id + '/' + _this.formData.Array + '/' + _this.formData.Gene)
        //     .then(function (response){
        //       console.log("gene_expression:")
        //       console.log(response.data)
        //       _this.SVG.data = response.data.data
        //       _this.changeSummit()
        //     })
        //echarts
        _this.$axios.get(
            'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/marker/gene/echarts/'
            + _this.$route.params.id + '/' + _this.formData.Array + '/' + _this.formData.Gene)
            .then(function (response){
              console.log("gene_expression:")
              console.log(response.data)
              _this.SVG.data = response.data.data
              if(response.status === 200){
                Vue.prototype.$message.success("success!")
              }
              _this.changeSummit()
            }).catch(function (e) {
          console.log(e)
          Vue.prototype.$message.error("Something is wrong...")
        })

        //SVG写法
        // _this.$axios.get(
        //     'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/marker/gene/'
        //     + _this.$route.params.id + '/' + _this.formData.Array + '/' + _this.formData.Gene)
        //     .then(function (response){
        //       console.log("gene_expression:")
        //       console.log(response.data)
        //       _this.SVG.data = response.data.data
        //       _this.changeSummit()
        //     })
      }
      else if(_this.isSVG === false){
        Vue.prototype.$message.info("drawing picture, please wait...")
        console.log("request R data")
        _this.$axios.post(
            'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/marker/run',
            _this.formData)
            .then(function (response){
              console.log("pic:")
              console.log(response.data)
              _this.imgPath = response.data
              Vue.prototype.$message.success("success!")
            })
            .catch(function (){
              Vue.prototype.$message.error("Something is wrong...")
            })
      }else {
        console.log("wait isSVG init")
      }
    },
    download(){
      if (this.isSVG === true){

        //svg下载
        // var mysvg = document.getElementById("mySVG");
        // let width = this.SVG.width
        // let height = this.SVG.height
        // console.log(width)
        // this.covertSVG2Image(mysvg,"img",width,height)
      }else {
        //创建一个a标签
        const a_b = document.createElement('a');
        //设置href指向
        a_b.href = this.imgPath;
        //设置图片下载名字
        // a_b.download = name;
        //点击a标签
        a_b.click()
      }

    },
    //echarts方法
    initEcharts(){
      const chartDom = document.getElementById('main');
      const myChart = echarts.init(chartDom);
      let option;

      const schema = [
        { name: 'x', index: 0, text: 'x' },
        { name: 'y', index: 1, text: 'y' },
        { name: 'gene', index: 2, text: 'gene' },
        { name: 'expression', index: 3, text: 'expression' },
      ];
      // const itemStyle = {
      //   emphasis: {
      //     focus : 'self'
      //   }
      // };
      option = {
        color: ['#ff0000'],
        toolbox: {
          feature: {
            saveAsImage: {
              show: true,
              title: "save",
              name: "marker.png",
            },
          },
        },
        grid: {
          right: '15%',
        },
        visualMap: [
          {
            left: 'right',
            bottom: '40%',
            dimension: 3,
            type: 'continuous',
            calculable:true,                        //是否显示拖拽用的手柄（手柄能拖拽调整选中范围）
            realtime:true,                          //拖拽时，是否实时更新
            precision:2,                            //数据展示的小数精度，默认为0，无小数点
            min: 0,
            max: 10,
            itemHeight: 120,
            align:"auto",
            text: ['expression'],
            textGap: 20,
            inRange: {
              color: ['blue','yellow', 'red']
            },
            outOfRange: {
              color: ['rgba(255,255,255,0.4)']
            },
            controller: {
              inRange: {
                color: ['blue','yellow', 'red']
              },
              outOfRange: {
                color: ['#999']
              }
            }
          }
        ],
        tooltip: {
          backgroundColor: 'rgba(255,255,255,0.7)',
          formatter: function (param) {
            // console.log(param)
            var value = param.value;
            // prettier-ignore
            return '<div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">'
                + schema[2].text + '：' + value[2]
                + '</div>'
                + schema[0].text + '：' + value[0] + '<br>'
                + schema[1].text + '：' + value[1] + '<br>'
                + schema[3].text + '：' + value[3] + '<br>';
          }
        },
        xAxis: {},
        yAxis: {},
        series: [
          {
            symbolSize: 10,
            data: [
              [1, 1,'a',20],
              [8.07, 6.95],
              [13.0, 7.58],
              [9.05, 8.81],
              [11.0, 8.33],
              [14.0, 7.66],
              [13.4, 6.81],
              [10.0, 6.33],
              [14.0, 8.96],
              [12.5, 6.82],
              [9.15, 7.2],
              [11.5, 7.2],
              [3.03, 4.23],
              [12.2, 7.83],
              [2.02, 4.47],
              [1.05, 3.33],
              [4.05, 4.96],
              [6.03, 7.24],
              [12.0, 6.26],
              [12.0, 8.84],
              [7.08, 5.82],
              [5.02, 5.68]
            ],
            type: 'scatter'
          }
        ]
      };
      option && myChart.setOption(option);

    },
    changeSummit() {
      let _this = this
      const myChart = echarts.getInstanceByDom(document.getElementById('main'));
      // if (chartDom == null) { // 如果不存在，就进行初始化。
      //   chartDom = echarts.init(document.getElementById(id));
      // }
      // const myChart = echarts.init(chartDom);
      let option;
      myChart.setOption({
        series: [
          {
            symbolSize: 10,
            data: _this.SVG.data,
            type: 'scatter'
          }
        ]
      })
      // chartDom.setAttribute('_echarts_instance_', '')
      option && myChart.setOption(option,true);
    },
    //svg方法
    covertSVG2Image(node, name, width, height, type = 'png'){
      let serializer = new XMLSerializer()
      let source = '<?xml version="1.0" standalone="no"?>\r\n' + serializer.serializeToString(node)
      let image = new Image()
      image.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(source)
      let canvas = document.createElement('canvas')
      canvas.width = width
      canvas.height = height
      let context = canvas.getContext('2d')
      context.fillStyle = '#fff'
      context.fillRect(0, 0, 10000, 10000)
      image.onload = function () {
        context.drawImage(image, 0, 0)
        let a = document.createElement('a')
        a.download = `${name}.${type}`
        a.href = canvas.toDataURL(`image/${type}`)
        a.click()
      }
    },
    clearSVG(){
      console.log("clearSVG")
      var svgDoc = document.getElementById("mySVG");
      if (this.SVG.data.length !== 0){
        let circles = svgDoc.querySelectorAll('circle')
        if(circles.length !== 0){
          console.log(circles)
          for (let i = 0;i<circles.length;i++){
            svgDoc.removeChild(circles[i])
          }
        }
      }
      // svgDoc.removeChild(circles)
      // let circles = svgDoc.getElementsByTagNameNS('http://www.w3.org/2000/svg', 'circle')
      // for (let i = 0;i<circles.length;i++){
      //   svgDoc.removeChild(circles.item(i))
      // }
    },
    drawSVG(){
      // console.log(this.SVG.data)
      this.createCircle(this.SVG.data)
    },
    createCircle(array){
      var svgDoc = document.getElementById("mySVG");
      for (let i in array) {
        // console.log(i)
        // console.log(array[i].x)
        // console.log(array[i].y)
        // console.log(array[i].expression)
        let c = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        c.setAttribute('cx', Number(array[i].x)*17);
        c.setAttribute('cy',  Number(array[i].y)*17);
        c.setAttribute('r',2);
        c.setAttribute('fill', 'red');
        // c.addEventListener("click", function() {
        //   let c_temp = c
        //   var title = document.createElementNS("http://www.w3.org/2000/svg","title");
        //   var text = document.createTextNode("x:"+data.x+"\ny:"+data.y+"\nexpression:"+data.expression);
        //   title.appendChild(text);
        //   c_temp.appendChild(title);
        // });
        c.addEventListener("mouseover", function() {
          let c_temp = c
          var title = document.createElementNS("http://www.w3.org/2000/svg","title");
          var text = document.createTextNode("x:"+array[i].x+"\ny:"+array[i].y+"\nexpression:"+array[i].expression);
          title.appendChild(text);
          c_temp.setAttribute("r",4);
          c_temp.appendChild(title);
        });
        c.addEventListener("mouseleave", function() {
          c.setAttribute("r",2);
        });
        svgDoc.appendChild(c);
      }


      // // 添加文本
      // var t = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      // t.setAttribute("x", parseInt(data.x) + 5);
      // t.setAttribute("y", parseInt(data.y) + 10);
      // t.setAttribute("font-size", "20");
      // t.setAttribute('fill', 'green');
      // t.addEventListener("click", function() {
      //   alert('文本点击测试：' + data.nodeText);
      // });
      // t.addEventListener("mouseover", function() {
      //   console.log('文本鼠标悬停测试：' + data.nodeText);
      // });
      // t.innerHTML = data.nodeText;
      // svgDoc.appendChild(t);

    }

  }
}
</script>

<style scoped>
#content{
  width: 100%;
  display: flex;
  justify-content: space-between;
}
#left{
  margin-top: 10px;
  width: 400px;
}
#left .el-form-item .el-select {
  width: 100%;
}
#right{
  width: 60%;
  float: left;
  /*max-width: 400px;*/
  /*max-height: 400px;*/
}
.class_show{
  display: block;
}
.class_hide{
   display: none;
 }
</style>
